module.exports = "/images/vendor/flag-icon-css/flags/1x1/sm.svg?f56650007eb0fc2472dd470c71193f45";